import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { useThemeScoreColor } from '../../hooks';

type Props = {
  score: number;
};

export function ScoreProgressBar({ score }: Readonly<Props>) {
  const color = useThemeScoreColor(score);
  return (
    <Box mt={1.5}>
      <Typography variant="caption" color="text.secondary">
        Score
      </Typography>
      <LinearProgress
        variant="determinate"
        value={score}
        sx={{
          height: 8,
          borderRadius: 5,
          mt: 0.5,
          backgroundColor: '#eee',
          '& .MuiLinearProgress-bar1': {
            backgroundColor: `${color} !important`, // <-- Add !important to override inline styles
          },
        }}
      />
      <Typography variant="caption">{score}/100</Typography>
    </Box>
  );
}
